import { render } from "./MyRegister_ok.vue?vue&type=template&id=8aef1c88"
import script from "./MyRegister_ok.vue?vue&type=script&lang=js"
export * from "./MyRegister_ok.vue?vue&type=script&lang=js"

import "./MyRegister_ok.vue?vue&type=style&index=0&id=8aef1c88&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__